import { Tabs, Tab } from "react-bootstrap";
import AtributosDesvinculadosEtapa from "./AtributosEtapaDesvinculadas";
import AtributosEtapaVinculadas from "./AtributosEtapaVinculadas";

interface IEditarAtributosEtapaProps {
    idEtapa: number;
    idTipoCaso: number;
    ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO?: number;
    ID_ETAPA_TIPO_CASO?: number;
}

export default function EditarAtributosEtapa(
    props: IEditarAtributosEtapaProps
) {
    return (
        <Tabs defaultActiveKey="vinculados" unmountOnExit>
            <Tab
                title="Atributos Vinculados"
                eventKey="vinculados"
                mountOnEnter
            >
                <div className="p-5">
                    <AtributosEtapaVinculadas
                        idEtapa={props.idEtapa}
                        idTipoCaso={props.idTipoCaso}
                    />
                </div>
            </Tab>
            <Tab
                title="Atributos Desvinculados"
                eventKey="desvinculados"
                mountOnEnter
            >
                <div className="p-5">
                    <AtributosDesvinculadosEtapa
                        idEtapa={props.idEtapa}
                        idTipoCaso={props.idTipoCaso}
                        ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO={
                            props.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                        }
                        ID_ETAPA_TIPO_CASO={props.ID_ETAPA_TIPO_CASO}
                    />
                </div>
            </Tab>
        </Tabs>
    );
}
